// eslint-disable
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const en_landing_app_description = /** @type {(inputs: {}) => string} */ () => {
	return `is a language learning app that uses flashcard with FSRS (Free Spaced Repetition System) to maximise memory retention while minimising the amount of efforts you need.`
};

const id_landing_app_description = /** @type {(inputs: {}) => string} */ () => {
	return `adalah aplikasi pembelajaran bahasa yang menggunakan kartu flash dengan FSRS (Free Spaced Repetition System) untuk memaksimalkan retensi memori sambil meminimalkan jumlah usaha yang Anda perlukan.`
};

const ja_landing_app_description = /** @type {(inputs: {}) => string} */ () => {
	return `は、FSRS (Free Spaced Repetition System) を備えたフラッシュカードを使用して、必要な努力を最小限に抑えながら記憶の保持を最大限にする言語学習アプリです。`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "id" | "ja" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const landing_app_description = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.landing_app_description(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("landing_app_description", locale)
	if (locale === "en") return en_landing_app_description(inputs)
	if (locale === "id") return id_landing_app_description(inputs)
	return ja_landing_app_description(inputs)
};
export { landing_app_description as "landing.app_description" }